// 水晶类型数据
const crystalTypes = [
  {
    id: 1,
    name: "紫水晶",
    description: "紫水晶是石英的一种变体，以其紫色调而闻名。它被认为具有强大的保护和净化能量。",
    energyProperties: "净化负面能量，增强直觉，促进冥想和灵性成长，连接高我。",
    element: "风",
    chakra: "顶轮（第七脉轮）",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/amethyst_geode_closeup_ca53ad8d.webp"
  },
  {
    id: 2,
    name: "粉晶",
    description: "粉晶是石英家族的一员，以其柔和的粉红色而著称。它被称为'爱的石头'。",
    energyProperties: "促进自爱和人际关系和谐，疗愈情感创伤，吸引爱情，增强同理心。",
    element: "水",
    chakra: "心轮（第四脉轮）",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/raw_rose_quartz_macro_view_a4d000d1.webp"
  },
  {
    id: 3,
    name: "黄水晶",
    description: "黄水晶是石英的一种变体，以其明亮的黄色或金色调而闻名。它被称为'财富之石'。",
    energyProperties: "吸引丰盛和财富，增强自信和个人意志，促进积极思维，激发创造力。",
    element: "火",
    chakra: "太阳神经丛脉轮（第三脉轮）",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/citrine_crystal_macro_shot_0ddc20cc.webp"
  },
  {
    id: 4,
    name: "白水晶",
    description: "白水晶是最纯净的石英形式，以其透明度和多功能性而著称。它被称为'万能水晶'。",
    energyProperties: "放大能量，净化和平衡所有脉轮，增强意念力，提高冥想效果。",
    element: "风",
    chakra: "所有脉轮",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/clear_quartz_crystal_closeup_39f78c0a.webp"
  },
  {
    id: 5,
    name: "黑曜石",
    description: "黑曜石是火山玻璃，由熔岩快速冷却形成。它以其强大的保护特性而闻名。",
    energyProperties: "提供保护，抵挡负面能量，揭示内在真相，促进灵性成长和自我认知。",
    element: "土",
    chakra: "根脉轮（第一脉轮）",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/obsidian_stone_closeup_with_rainbow_sheen_00551ae3.webp"
  },
  {
    id: 6,
    name: "混合水晶",
    description: "多种水晶的组合，用于平衡和协调不同的能量。",
    energyProperties: "根据组合的水晶类型提供综合能量效果，平衡多个脉轮。",
    element: "多元素",
    chakra: "多脉轮",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/amethyst_geode_closeup_ca53ad8d.webp"
  },
  {
    id: 7,
    name: "月光石",
    description: "月光石是长石家族的一员，以其特殊的蓝色光彩效应而闻名。",
    energyProperties: "增强女性力量、直觉和创造力，平衡情绪，促进和谐与内在成长。",
    element: "水",
    chakra: "眉心轮（第六脉轮）和顶轮（第七脉轮）",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/moonstone_ring.webp"
  },
  {
    id: 8,
    name: "青金石",
    description: "青金石是一种深蓝色的宝石，常带有金色的黄铁矿斑点。",
    energyProperties: "促进真实表达，增强智慧和洞察力，激活第三只眼，连接高级意识。",
    element: "水",
    chakra: "喉轮（第五脉轮）和眉心轮（第六脉轮）",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/clear_quartz_crystal_closeup_39f78c0a.webp"
  },
  {
    id: 9,
    name: "绿aventurine",
    description: "绿aventurine是石英的一种变体，以其闪光效应和绿色调而闻名。",
    energyProperties: "吸引好运和机遇，促进繁荣和丰盛，平衡情绪，支持心脏健康。",
    element: "土",
    chakra: "心轮（第四脉轮）",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/natural_citrine_crystal_piece_on_white_background_2aa1081e.webp"
  },
  {
    id: 10,
    name: "红玉髓",
    description: "红玉髓是玉髓的一种变体，以其红色或橙红色调而闻名。",
    energyProperties: "增强活力和生命力，激发勇气和决心，支持根脉轮，促进稳定和安全感。",
    element: "火",
    chakra: "根脉轮（第一脉轮）",
    imageUrl: process.env.PUBLIC_URL + "/assets/images/products/natural_black_obsidian_raw_stone_on_white_background_ec0d8bde.webp"
  }
];

export { crystalTypes };